/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import SessionStore from '../../store/SessionStore'
import SiteReferrersStore from '../../store/site_referrer/SiteReferrersStore'
import ListView from '../../view/pages/site_referer/ListView'
import SiteReferrerAction from '../../action/site_referrer'

class ListContainer extends Component {
  static getStores() {
    return [SessionStore, SiteReferrersStore]
  }

  static calculateState(prevState, props) {
    return {
      session: SessionStore.getState(),
      site_referrers: SiteReferrersStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    SiteReferrerAction.fetchAll()
  }

  render() {
    return ListView(this.state)
  }
}

export default withRouter(Container.create(ListContainer, { withProps: true }))
